import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NonUniqueSymbolError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.product.validation.symbol.non-unique');
    }
}
